import axios, { AxiosResponse } from 'axios'
import { Location } from './models/Common/Location'
import {
  GetAddressResponse,
  GetTimeZoneResponse,
  PartialAddressSuggestion,
  Suggestions,
} from './models/GetAddress.type'
import { getUserToken } from './utility/localStorageFunctions'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/locationServices-api/locationServices`

const autoCompleteAddress = async (
  address: string,
  clientId?: number,
): Promise<AxiosResponse<Suggestions>> => {
  const token = await getUserToken('locationServices')

  const effectiveClientId = clientId ?? 0
  const url = BASE_URL.concat(
    `/address/search?address=${address}&clientId=${effectiveClientId}`,
  )

  const response = await axios({
    method: 'get',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url,
  })

  return response
}

const getAddress = async (
  address: string,
): Promise<AxiosResponse<GetAddressResponse>> => {
  const token = await getUserToken('locationServices')

  const response = await axios({
    method: 'get',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: BASE_URL.concat(
      `/address/geocode?address=${encodeURIComponent(address)}`,
    ),
  })
  return response
}

const getAddressById = async (
  suggestion: PartialAddressSuggestion,
): Promise<AxiosResponse<Location>> => {
  const token = await getUserToken('locationServices')

  const response = await axios({
    method: 'get',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: BASE_URL.concat(
      `/address/${suggestion.id}?addressSourceType=${suggestion.addressSourceTypeName}`,
    ),
  })
  return response
}

const getTimeZone = async (
  lat: number,
  long: number,
): Promise<AxiosResponse<GetTimeZoneResponse>> => {
  const token = await getUserToken('locationServices')

  const response = await axios({
    method: 'get',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: BASE_URL.concat(
      `/timezone/retrieveForCoordinates?lat=${lat}&lng=${long}`,
    ),
  })
  console.log('timezoneAPI response: ', response)
  return response
}

export const locationsAPI = {
  autoCompleteAddress,
  getAddress,
  getAddressById,
  getTimeZone,
}
